import "./blog.css";
import { Link } from "react-router-dom";
import { getSortedBlogPosts, formatDate } from "./blog-posts-config";

export default function Blog() {
  const blogPosts = getSortedBlogPosts();

  return (
    <div className="blog">
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        paddingTop: '2rem'
      }}>
        
      </div>

      <div className="blog-section">
        
        <h1 style={{
          fontFamily: 'var(--font-family)',
          textAlign: 'center',
          fontSize: '4rem',
          lineHeight: '1.2',
          maxWidth: '1000px',
          margin: '0 auto 4rem'
        }}>
          Insights from Our Lab
        </h1>
      </div>

      <div className="blog-content" style={{maxWidth: '800px', margin: '0 auto', padding: '0 2rem'}}>
        <div className="blog-list">
          {blogPosts.map((post) => (
            <div key={post.id} className="blog-post">
              <h2>
                <Link to={post.route}>
                  {post.title}
                </Link>
              </h2>
              <p className="blog-date">{formatDate(post.date)}</p>
              <p className="blog-excerpt">
                {post.excerpt}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
} 